import React, {useRef, useImperativeHandle, forwardRef} from 'react'

import {Badge, Colors, Popup} from '../../src/components/UI/index.js'
import {Reseller, Shift} from 'types/types.js'
import type {PopupRef} from '../../src/components/UI/overlays/Popup.js'

type SelectShiftPopupProps = {
    reseller: Reseller
}

type SelectShiftPopupRef = {
    open: (shifts: Shift[], selectedShift: string) => Promise<string | undefined>
    close: () => Promise<void>
}

const getBadge = (shift: Shift) => {
    if (shift?.completed) {
        return <Badge variant='success'>Afgerond</Badge>
    }

    if (shift?.started) {
        return <Badge textColor={Colors.textDark} variant='info'>Onderweg</Badge>
    }

    return <Badge variant='grey'>Niet gestart</Badge>
}

const SelectShiftPopup = forwardRef((props: SelectShiftPopupProps, ref: React.RefObject<SelectShiftPopupRef>) => {
    const popupRef = useRef<PopupRef>(null)

    const open = async (shifts: Shift[], selectedShift: string) => {
        const option = await popupRef.current.openOptions('Dienst selecteren', '', shifts.map((shift) => ({
            title: `${shift.name}${shift.plannedStartTime ? ` (${shift.plannedStartTime})` : ''}`,
            value: shift._id,
            ellipsis: false,
            selected: shift._id === selectedShift,
            append: getBadge(shift)
        })))

        return option?.value
    }

    useImperativeHandle(ref, () => ({
        open,
        close: popupRef.current.close
    }))

    return (
        <Popup ref={popupRef} closeButton showOptionRadioButton />
    )
})

SelectShiftPopup.displayName = 'SelectShiftPopup'

export default SelectShiftPopup
